import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function ShortTestimonials() {
  const testimonials = [{
    text: 'Llegaba a los entrenamientos con ideas sueltas y sin un hilo conductor. Con el Megapack armé todo el año en una tarde. Ahora cada sesión tiene sentido y mis jugadores lo notan.',
    author: 'Sebastián M.',
    role: 'Instructor de Fútbol Amateur',
    location: 'Buenos Aires'
  }, {
    text: 'Mis jugadores mejoraron más en 2 meses con el sistema de progresión que en todo el año anterior. La organización por niveles y objetivos cambió todo.',
    author: 'Diego R.',
    role: 'Profe en Club de Barrio',
    location: 'Rosario'
  }, {
    text: 'Ahora adapto el mismo ejercicio para distintas categorías en minutos. Antes me pasaba horas pensando qué trabajar con cada grupo.',
    author: 'Matías F.',
    role: 'Instructor Multidisciplinario',
    location: 'Córdoba'
  }];
  return <Section className="bg-gray-50" data-id="element-343">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8" data-id="element-344">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-4 md:p-8 rounded-xl md:rounded-2xl shadow-sm border border-gray-100 relative border-t-4 border-t-primary hover:shadow-md transition-shadow" data-id="element-345">
            <Quote className="absolute top-4 right-4 w-6 h-6 md:w-8 md:h-8 text-primary/10" data-id="element-346" />
            <div className="flex mb-2 md:mb-4" data-id="element-347">
              {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-sm md:text-xl" data-id="element-348">
                  ⭐
                </span>)}
            </div>
            <p className="text-gray-700 italic mb-3 md:mb-6 leading-relaxed font-medium text-sm md:text-base" data-id="element-349">
              "{t.text}"
            </p>
            <div data-id="element-350">
              <p className="font-bold text-dark text-sm md:text-base" data-id="element-351">
                {t.author}
              </p>
              <p className="text-xs md:text-sm text-gray-500" data-id="element-352">
                {t.location} — {t.role}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}